var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigmaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 44,
    viewBox: "0 0 29 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2457 21.8737C14.2457 19.9993 14.9903 18.2016 16.3157 16.8762C17.6411 15.5508 19.4387 14.8062 21.3131 14.8062C23.1876 14.8062 24.9852 15.5508 26.3106 16.8762C27.636 18.2016 28.3806 19.9993 28.3806 21.8737C28.3806 23.7481 27.636 25.5457 26.3106 26.8711C24.9852 28.1966 23.1876 28.9412 21.3131 28.9412C19.4387 28.9412 17.6411 28.1966 16.3157 26.8711C14.9903 25.5457 14.2457 23.7481 14.2457 21.8737Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.110718 36.0086C0.110718 34.1342 0.855324 32.3366 2.18073 31.0112C3.50614 29.6858 5.30378 28.9412 7.17819 28.9412H14.2457V36.0086C14.2457 37.883 13.5011 39.6807 12.1757 41.0061C10.8502 42.3315 9.0526 43.0761 7.17819 43.0761C5.30378 43.0761 3.50614 42.3315 2.18073 41.0061C0.855324 39.6807 0.110718 37.883 0.110718 36.0086H0.110718Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2457 0.671265V14.8062H21.3131C23.1876 14.8062 24.9852 14.0616 26.3106 12.7362C27.636 11.4108 28.3806 9.61315 28.3806 7.73874C28.3806 5.86433 27.636 4.06669 26.3106 2.74128C24.9852 1.41587 23.1876 0.671265 21.3131 0.671265L14.2457 0.671265Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.110718 7.73874C0.110718 9.61315 0.855324 11.4108 2.18073 12.7362C3.50614 14.0616 5.30378 14.8062 7.17819 14.8062H14.2457V0.671265H7.17819C5.30378 0.671265 3.50614 1.41587 2.18073 2.74128C0.855324 4.06669 0.110718 5.86433 0.110718 7.73874H0.110718Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.110718 21.8737C0.110718 23.7481 0.855324 25.5457 2.18073 26.8711C3.50614 28.1966 5.30378 28.9412 7.17819 28.9412H14.2457V14.8062H7.17819C5.30378 14.8062 3.50614 15.5508 2.18073 16.8762C0.855324 18.2016 0.110718 19.9993 0.110718 21.8737H0.110718Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2699,
    height: 42.4048,
    fill: "white",
    transform: "translate(0.110718 0.671265)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaIcon);
export default __webpack_public_path__ + "static/media/figma-icon.424c4031b0047133d4757f962d83dab0.svg";
export { ForwardRef as ReactComponent };